/**
 * MG Time Tracker Application
 *
 *	CheckboxField.js
 *
 *
 */

// React Imports
import React, { Component } from 'react';

// SASS Imports
require('./InputField.scss');

class CheckboxField extends Component {
    render() {
        const classes = [ 'checkbox' ];

        if (this.props.colClass) {
            classes.push(this.props.colClass);
        }
        if (this.props.hidden) {
            classes.push('hidden');
        }
        if (this.props.hasError) {
            classes.push('has-error');
        }

        return (
            <div className={classes.join(' ')}>
                <div className={this.props.disabledClass}>
                    <label>
                        <input
                            type="checkbox"
                            value={this.props.value}
                            checked={this.props.checked}
                            onChange={this.props.onChange}
                            disabled={this.props.disabled}
                        />
                        {this.props.title}
                    </label>
                </div>
            </div>
        );
    }
}

export default CheckboxField;



// WEBPACK FOOTER //
// ./app/components/TimeInput/InputTypes/CheckboxField.jsx